import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import Index from '@pages/index.js'
import Events from '@pages/events/index.js'
import EventsView from '@pages/events/view/index.js'
import News from '@pages/news/index.js'
import NewsView from '@pages/news/view/index.js'
import Promotions from '@pages/promotions/index.js'
import Blog from '@pages/blog/index.js'
import BlogView from '@pages/blog/view/index.js'
import PromotionsView from '@pages/promotions/view/index.js'
import Team from '@pages/team/index.js'
import Media from '@pages/media/index.js'
import MediaView from '@pages/media/view/index.js'
import Reviews from '@pages/reviews/index.js'
import BecomeVendor from '@pages/become-vendor/index.js'
import BecomePartner from '@pages/become-partner/index.js'
import ArchivePromotions from '@pages/archive-promotions/index.js'
import QualityPolicy from '@pages/quality-policy/index.js'
import Contacts from '@pages/contacts/index.js'
// import ArchiveEvents from '@pages/archive-events/index.js';
import UserAgreement from '@pages/user-agreement/index.js'
import StaticPage from '@pages/pages/_id/index.js'
import PressCenter from '@pages/press-center/index.js'
import About from '@pages/about/index.js'
import Career from '@pages/career/index.js'
import CareerView from '@pages/career/view/index.js'
import Services from '@pages/services/index.js'
import ServicesView from '@pages/services/view/index.js'
import Cases from '@pages/cases/index.js'
import CasesView from '@pages/cases/view/index.js'
import Documents from '@pages/documents/index.js'
import Vendors from '@pages/vendors/index.js'
import VendorsView from '@pages/vendors/view/index.js'
// import Practices from '@pages/practices/index.js';
// import PracticesView from '@pages/practices/view/index.js';
import Questionnaires from '@pages/questionnaires/index.js'
import QuestionnairesView from '@pages/questionnaires/view/index.js'
import Decisions from '@pages/decisions/index.js'
import DecisionsCategory from '@pages/decisions/category/index.js'
import DecisionsCategoryId from '@pages/decisions/category/id/index.js'
import Search from '@pages/search/index.js'
import AxoftMaxPro from '@pages/axoft-maximum-pro/index.vue'

import Lk from '@pages/lk/index.vue'
import LkMain from '@pages/lk/main/index.vue'
import LkProfile from '@pages/lk/profile/index.vue'
import LkSecurity from '@pages/lk/profile/security/index.vue'
// import LkSubscription from '@pages/lk/profile/subscription/index.vue';
import LkNotification from '@pages/lk/profile/notification/index.vue'
// import LkStaff from '@pages/lk/profile/staff/index.vue';
import LkFaq from '@pages/lk/faq/index.vue'
import LkFaqCategory from '@pages/lk/faq/category/index.vue'
import LkFaqCategoryQuestion from '@pages/lk/faq/category/question/index.vue'
import LkPromotions from '@pages/lk/promotions/index.vue'
import LkRequests from '@pages/lk/requests/index.vue'
import LkRequestsView from '@pages/lk/requests/view/index.vue'
import LkEvents from '@pages/lk/events/index.vue'
import LkEventsPhotos from '@pages/lk/events/photos/index.vue'
import LkEventsId from '@pages/lk/events/id/index.vue'
import LkNotifications from '@pages/lk/notifications/index.vue'
import LkCompetencies from '@pages/lk/competencies/index.vue'
import LkPriceLists from '@pages/lk/price-lists/index.vue'
import LkPriceListsFavorites from '@pages/lk/price-lists/favorites/index.vue'
import LkServices from '@pages/lk/services/index.vue'
import LkLeads from '@pages/lk/leads/index.vue'
import LkLeadsView from '@pages/lk/leads/view/index.vue'
import LkRatingHistory from '@pages/lk/rating-history/index.vue'
import LkMaterials from '@pages/lk/materials/index.vue'
import LkMaterialsOnlineCourses from '@pages/lk/materials/materials-online-courses/index.vue'
import LkMaterialsOnlineCoursesId from '@pages/lk/materials/materials-online-courses/id/index.vue'
import LkMaterialsVendors from '@pages/lk/materials/materials-vendors/index.vue'
import LkMaterialsVendorsId from '@pages/lk/materials/materials-vendors/id/index.vue'
import LkMaterialsWhiteLabel from '@pages/lk/materials/materials-white-label/index.vue'
import LkMaterialsWhiteLabelId from '@pages/lk/materials/materials-white-label/id/index.vue'

import E404 from '@pages/404/index.js'
import E403 from '@pages/403/index.js'
import Reload from '@components/base/reload.vue'

const routes = [
  {
    path: '/',
    name: 'main',
    component: Index,
  },
  {
    path: '/events',
    name: 'events',
    component: Events,
  },
  {
    path: '/events/:id',
    name: 'eventsView',
    component: EventsView,
  },
  {
    path: '/news',
    name: 'news',
    component: News,
  },
  {
    path: '/news/:id',
    name: 'newsView',
    component: NewsView,
  },
  {
    path: '/promotions',
    name: 'promotions',
    component: Promotions,
  },
  {
    path: '/promotions/:id',
    name: 'promotionsView',
    component: PromotionsView,
  },
  {
    path: '/team',
    name: 'team',
    component: Team,
  },
  {
    path: '/blog',
    name: 'blog',
    component: Blog,
  },
  {
    path: '/blog/:id',
    name: 'blogView',
    component: BlogView,
  },
  {
    path: '/media',
    name: 'media',
    component: Media,
  },
  {
    path: '/media/:id',
    name: 'mediaView',
    component: MediaView,
  },
  {
    path: '/reviews',
    name: 'reviews',
    component: Reviews,
  },
  {
    path: '/become-vendor',
    name: 'BecomeVendor',
    component: BecomeVendor,
  },
  {
    path: '/become-partner',
    name: 'BecomePartner',
    component: BecomePartner,
  },
  {
    path: '/quality-policy',
    name: 'QualityPolicy',
    component: QualityPolicy,
  },
  {
    path: '/archive-promotions',
    name: 'ArchivePromotions',
    component: ArchivePromotions,
  },
  // {
  //     path: '/archive-events',
  //     name: 'ArchiveEvents',
  //     component: ArchiveEvents,
  // },
  {
    path: '/contacts',
    name: 'Contacts',
    component: Contacts,
  },
  {
    path: '/user-agreement',
    name: 'UserAgreement',
    component: UserAgreement,
  },
  {
    path: '/press-center',
    name: 'PressCenter',
    component: PressCenter,
  },
  {
    path: '/about',
    name: 'about',
    component: About,
  },
  {
    path: '/career',
    name: 'career',
    component: Career,
  },
  {
    path: '/career/:id',
    name: 'careerView',
    component: CareerView,
  },
  {
    path: '/cases',
    name: 'cases',
    component: Cases,
  },
  {
    path: '/cases/:id',
    name: 'casesView',
    component: CasesView,
  },
  {
    path: '/services',
    name: 'services',
    component: Services,
  },
  {
    path: '/services/:id',
    name: 'servicesView',
    component: ServicesView,
  },
  {
    path: '/documents',
    name: 'documents',
    component: Documents,
  },
  {
    path: '/vendors',
    name: 'vendors',
    component: Vendors,
  },
  {
    path: '/vendors/:view',
    name: 'vendorsView',
    component: VendorsView,
  },
  {
    path: '/questionnaires',
    name: 'questionnaires',
    component: Questionnaires,
  },
  {
    path: '/questionnaires/:id',
    name: 'questionnairesView',
    component: QuestionnairesView,
  },
  {
    path: '/decisions',
    name: 'decisions',
    component: Decisions,
  },
  {
    path: '/decisions/:category',
    name: 'decisionsCategory',
    component: DecisionsCategory,
  },
  {
    path: '/decisions/:category/:id',
    name: 'decisionsCategoryId',
    component: DecisionsCategoryId,
  },
  {
    path: '/search',
    name: 'search',
    component: Search,
  },
  {
    path: '/axoft-maximum-pro',
    name: 'axoft-max-pro',
    component: AxoftMaxPro,
  },
  {
    path: '/lk',
    // name: 'lk',
    component: Lk,
    children: [
      {
        path: '/lk',
        name: 'lk-main',
        component: LkMain,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'profile',
        // name: 'lk-profile',
        component: LkProfile,
        children: [
          {
            path: '',
            name: 'lk-security',
            component: LkSecurity,
            meta: {
              requiresAuth: true,
            },
          },
          // {
          //     path: 'subscription',
          //     name: 'lk-subscription',
          //     component: LkSubscription,
          //     meta: {
          //         requiresAuth: true
          //     },
          // },
          {
            path: 'notification',
            name: 'lk-notification',
            component: LkNotification,
            meta: {
              requiresAuth: true,
            },
          },
          // {
          //     path: 'staff',
          //     name: 'lk-staff',
          //     component: LkStaff,
          //     meta: {
          //         requiresAuth: true
          //     },
          // }
        ],
      },
      {
        path: 'faq',
        name: 'lk-faq',
        component: LkFaq,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'faq/:category',
        name: 'lk-faq-category',
        component: LkFaqCategory,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'faq/:category/:question',
        name: 'lk-faq-category-question',
        component: LkFaqCategoryQuestion,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'promotions',
        name: 'lk-promotions',
        component: LkPromotions,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'requests',
        name: 'lk-requests',
        component: LkRequests,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'requests/:view',
        name: 'lk-requests-view',
        component: LkRequestsView,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'events',
        name: 'lk-events',
        component: LkEvents,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'events/photos',
        name: 'lk-events-photos',
        component: LkEventsPhotos,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'events/:id',
        name: 'lk-events-id',
        component: LkEventsId,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'notifications',
        name: 'lk-notifications',
        component: LkNotifications,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'competencies',
        name: 'lk-competencies',
        component: LkCompetencies,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'price-lists',
        name: 'lk-price-lists',
        component: LkPriceLists,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'price-lists/favorites',
        name: 'lk-price-lists-favorites',
        component: LkPriceListsFavorites,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'services',
        name: 'lk-services',
        component: LkServices,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: process.env.NODE_ENV !== 'production' ? 'materials' : '',
        name: 'lk-materials',
        component: LkMaterials,
        children: [
          {
            path: 'materials-vendors',
            name: 'lk-materials-vendors',
            component: LkMaterialsVendors,
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: 'materials-white-label',
            name: 'lk-materials-white-label',
            component: LkMaterialsWhiteLabel,
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: 'materials-online-courses',
            name: 'lk-materials-online-courses',
            component: LkMaterialsOnlineCourses,
            meta: {
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: process.env.NODE_ENV !== 'production' ? 'materials/materials-online-courses/:id' : 'materials-online-courses/:id',
        name: 'lk-materials-online-courses-id',
        component: LkMaterialsOnlineCoursesId,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: process.env.NODE_ENV !== 'production' ? 'materials/materials-vendors/:id' : 'materials-vendors/:id',
        name: 'lk-materials-vendors-id',
        component: LkMaterialsVendorsId,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: process.env.NODE_ENV !== 'production' ? 'materials/materials-white-label/:id' : 'materials-white-label/:id',
        name: 'lk-materials-white-label-id',
        component: LkMaterialsWhiteLabelId,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'leads',
        name: 'lk-leads',
        component: LkLeads,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'leads/:view',
        name: 'lk-leads-view',
        component: LkLeadsView,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'rating-history',
        name: 'lk-rating-history',
        component: LkRatingHistory,
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/404',
    name: 'E404',
    component: E404,
  },
  {
    path: '/403',
    name: 'E403',
    component: E403,
  },
  {
    path: '/reload',
    name: 'reload',
    component: Reload,
  },
  {
    path: '/pages/:id',
    name: 'static-page',
    component: StaticPage,
  },
  {
    path: '*',
    component: E404,
  },
]

export const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (from.path === to.path || to.hash) {
      return false
    }

    if (savedPosition) {
      return savedPosition
    }

    return { x: 0, y: 0 }
  },
})



// WEBPACK FOOTER //
// ./src/routes.js